import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { ConfigService } from "./config-service";

@Injectable()
export class LoggerService {
  constructor(public http: HttpClient, public configService: ConfigService) {}

  public error(error, message?) {
    console.log(error, message, `${this.configService.nest_url}/logger`);
    return this.http
      .post(`${this.configService.nest_url}/logger`, {
        as: "error",
        message: message
          ? `[APP-OPERADOR/ENEL]: ${message}`
          : "Houve um erro na aplicação [Operador]",
        value: JSON.stringify(error),
      })
      .subscribe(console.log, console.log);
  }
}



// WEBPACK FOOTER //
// ./src/providers/logger-service.ts